import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "ss_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const http = axios.create({ baseURL: API });
http.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errorText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Noe gikk galt. Prøv igjen.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return String(d);
}

export async function streamSSE(path, body, onDelta) {
  const headers = { "Content-Type": "application/json" };
  const t = getToken();
  if (t) headers.Authorization = `Bearer ${t}`;
  const res = await fetch(`${API}${path}`, { method: "POST", headers, body: JSON.stringify(body) });
  if (!res.ok) throw new Error("Tilkoblingen feilet");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  let full = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const d = JSON.parse(p.slice(6));
      if (d.error) throw new Error(d.error);
      if (d.delta) {
        full += d.delta;
        onDelta(full);
      }
    }
  }
  return full;
}

export async function speak(text) {
  const { data } = await http.post("/tts", { text: text.slice(0, 3900) });
  const audio = new Audio(`data:audio/mp3;base64,${data.audio}`);
  await audio.play();
  return audio;
}
